// extracted by mini-css-extract-plugin
export default {"page":"page_page__ZSt6y","logo":"page_logo__8zp-J","title":"page_title__I-vIU"};